import React from 'react'
import InputFilter from './inputFilter'

const Filtering = ({ externalFilters, columns, setFilterQuery, callApi, values, searchBtnText }) => {


    const createSearchInputPlaceHolder = () => {
        let str = "Search by"
        columns.map((col, i) => {
            if (col.hasFilter) {
                str += i === 0 ? ` ${col.title}` : `,${col.title} `

            }
        })
        return str;
    }

    const handleSearchText = (e) => {
        const text = handleCreateSearchText(e, columns);
        setFilterQuery({ whereConditionText: text })
    }



    return (
        <div className='input-filter-container'>
            {!externalFilters && <InputFilter setFilterQuery={setFilterQuery} values={values} columns={columns} searchBtnText={searchBtnText} />}
            {externalFilters && externalFilters}
            <div className='ms-2'>
                {callApi &&
                    <button
                        onClick={callApi}
                        className='btn btn-primary' >{searchBtnText}</button>}
            </div>


        </div>
    )
}

export default Filtering


const handleCreateSearchText = (e, columns) => {
    const text = e.target.value;
    let searchQueryText = ""
    columns.map((col, i) => {
        if (col.hasFilter) {
            searchQueryText += searchQueryText === "" ?
                `${col.filterProperty ? col.filterProperty : col.property} like \"${text}\"` :
                ` or ${col.filterProperty ? col.filterProperty : col.property} like \"${text}\"`

        }
    })
    return searchQueryText;

}

// const FilterTag=({children})=>{

//     return(
//         <>
//         {children}
//         </>
//     )
// }
